import React from 'react';
import { Nav } from 'reactstrap';
import ProfileDropdown from './ProfileDropdown';
import ProfileMyEvents from './ProfileMyEvents';
import AccountSelector from './AccountSelector';
import AccountDisplay from './AccountDisplay';
import { useAuth } from '../../AuthContext';


const TopNavRightSideNavItem = () => {
    
  const { username, isAdmin, isLoggedIn } = useAuth();

  if (isLoggedIn){
    return (
        <Nav navbar className="navbar-nav-icons ml-auto flex-row align-items-center">
          <AccountDisplay />
          <ProfileMyEvents />
          <AccountSelector className="mr-3" />
          <ProfileDropdown username={username} isAdmin={isAdmin} />
        </Nav>
    );
  }
  else{
    return <></>;
  }

};

export default TopNavRightSideNavItem;
